import { Enum } from '@/helpers/choices/enum';
import { roles } from '@/rbac';

export class RolesEnum extends Enum {}

RolesEnum.values = roles;
RolesEnum.names = roles;
Object.freeze(RolesEnum);
